import { helpers } from '@vuelidate/validators'

export const equals = (value) =>
  helpers.withParams({ type: 'equals', value }, inpValue => {
    return inpValue === value
  })
